var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z","key":0}),React.createElement("path",{"className":"st1","d":"M385.8,201.8L247.1,340.4c-4.2,4.2-9.6,6.3-15.1,6.3s-10.9-2.1-15.1-6.3l-69.3-69.3c-8.3-8.3-8.3-21.8,0-30.2\n\tc8.3-8.3,21.8-8.3,30.2,0l54.2,54.2l123.6-123.6c8.3-8.3,21.8-8.3,30.2,0C394.1,179.9,394.1,193.4,385.8,201.8z","key":1})]);
}

CircleCheck.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
